export default "__VITE_ASSET__bNEHnJii__"